import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { AuthenticationService, CompanyService, QuestionTooltipService } from 'app/_services';
import { BaseComponent } from 'app/_components/base.component';
import { Company } from 'app/_models';
import { ProfileService, SandboxService } from 'app/_services';
import { GRANTS_BUREAU_ID, GRANTS_BUREAU_NAME } from 'app/app.constants';
import { resolveBureauFromUrlSegment } from 'app/_utils/helpers';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.scss']
})
export class SiteLayoutComponent extends BaseComponent implements OnInit {
  public companies: Company[];
  public companyLoaded: boolean = false;
  constructor(
    router: Router,
    authenticationService: AuthenticationService,
    companyService: CompanyService,
    private tooltipService: QuestionTooltipService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private sandboxService: SandboxService,
  ) {
    super(router, authenticationService, companyService);
    this.companies = [];
    this.route.params.subscribe((params) => {
      const { companyBureau } = params;
      this.companyService.list({}, true).subscribe(companies => {
        this.companies = companies;
        if (companyBureau) {
          const [companyName, bureauName] = companyBureau.split('.');
          let company;
          let bureau;
          if (companyName) {
            company = this.companies.find(c => c.name === companyName);
            if (company) {
              if (bureauName) {
                bureau = resolveBureauFromUrlSegment(company, bureauName)
                  || company.bureaus.find(p => p.name === bureauName);
              }
              if (!bureau && this.companyHasGrantsAccess(company) && !this.companyHasBureauAccess(company)) {
                bureau = { id: GRANTS_BUREAU_ID, name: GRANTS_BUREAU_NAME };
              }
              // If bureau missing or not found, default to first available for this company
              if (!bureau && company.bureaus && company.bureaus.length) {
                [bureau] = company.bureaus;
              }
              if (!bureau && this.companyHasGrantsAccess(company)) {
                bureau = { id: GRANTS_BUREAU_ID, name: GRANTS_BUREAU_NAME };
              }
              if (bureau) {
                this.authenticationService.setCurrentBureau(company.id, company.name, bureau.id, bureau.name);
                this.companyLoaded = true;
              }
            }
          }
        } else {
          this.companyLoaded = true;
        }
        if (!this.getCurrentCompanyId() || !this.getCurrentBureauId()) {
          let company;
          if (!this.getCurrentCompanyId()) {
            [company] = companies;
          } else {
            company = this.companies.find(c => c.id === this.getCurrentCompanyId());
          }
          if (company) {
            if (company.bureaus && company.bureaus.length) {
              const [bureau] = company.bureaus;
              if (bureau) {
                this.authenticationService.setCurrentBureau(company.id, company.name, bureau.id, bureau.name);
              }
            } else if (this.companyHasGrantsAccess(company)) {
              this.authenticationService.setCurrentBureau(company.id, company.name, GRANTS_BUREAU_ID, GRANTS_BUREAU_NAME);
            }
          }
        }
      });
      this.tooltipService.list().subscribe();
    });
  }

  isProfileLoaded() {
    return this.profileService.isProfileLoaded();
  }

  /** True while the signed-in client's own sandbox company is mid-refresh. */
  get sandboxHolding(): boolean {
    return this.sandboxService.holding$.value;
  }

  ngOnInit() {

  }
}
